import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import JBImage from 'components/essentials/JBImage';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';

const PDPDesktopMarxentConfigurator = ({
  slug,
  hideMarxent,
  unavailableFabric = false,
}) => {
  const { data } = usePDPBasicDetails();

  return (
    <>
      <Helmet>
        <link
          href="https://cdn.3dcloud.io/joy-sectional-config/7.2.0-12/JOYSectional-7.2.0-12.css"
          rel="stylesheet"
          type="text/css"
        />

        <script
          src="https://cdn.3dcloud.io/joy-sectional-config/7.2.0-12/JOYSectional-7.2.0-12.min.js"
          id={`marxent-script-${slug}`}
          type="text/javascript"
          async
          defer
        />
      </Helmet>

      <div className="border border-gray-light6 w-full h-[60vh] relative">
        <div className="w-full h-full flex justify-center items-center absolute">
          {data?.hero_images[0]?.img?.url && (
            <JBImage
              className="w-full h-full absolute object-cover z-0"
              src={data.hero_images[0].img.url}
              fit="crop"
              crop="center"
              width="600"
              height="400"
            />
          )}
          <div className="bg-gray-light9 absolute z-10 p-4 rounded-sm text-sm font-bold">
            Add a piece to get started!
          </div>
        </div>
        <div
          className={classnames(
            'w-full h-full absolute z-20 bg-gray-light9 transition-all duration-500',
            {
              'opacity-0': hideMarxent,
              'opacity-100': !hideMarxent,
            }
          )}
        >
          <div
            className="w-full h-full relative [&_.closeButton]:hidden"
            id={`marxent-configurator-${slug}`}
          />
        </div>
        {unavailableFabric && (
          <div className="w-full h-full flex justify-center items-center">
            <div className="bg-brand absolute z-30 px-4 py-2 rounded-md text-sm text-white font-bold text-center">
              This fabric is coming soon!
              <br />
              Check out our other fabrics while we get our ducks in a row.
            </div>
          </div>
        )}
      </div>
    </>
  );
};

PDPDesktopMarxentConfigurator.propTypes = {
  slug: PropTypes.string,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool,
};

export default PDPDesktopMarxentConfigurator;
